/**
 * 纯数据子入口 — 专供前端 (admin) 用。
 *
 * 为什么拆这个：`.` 主入口 re-export 了 feishu-client.ts（里面 `execFileSync`
 * 是 node-only API），vite 打前端 bundle 时即使 tree-shaking 也会因
 * side-effect 分析保守而报错。`./labels` 只暴露纯数据常量 + 类型。
 */
export { FIELD_MAP, cnToTsKey, fieldIdToTsKey } from './field-map.js';
export { FIELD_IDS } from './field-ids.generated.js';
/** 每张表在飞书里的中文表名（模板里是固定的，copy 后保持一致） */
export const TABLE_CN_NAMES = {
    brand_config: '品牌基础配置',
    sku: 'SKU 产品',
    brand_content: '品牌内容',
    deploy_config: '部署配置',
    engine_config: '内容引擎配置',
    certification: '资质认证',
    testimonial: '客户证言',
    exhibition: '展会记录',
};
//# sourceMappingURL=labels.js.map